import {Component, OnInit} from '@angular/core';
import {
  UntypedFormControl,
  UntypedFormGroup,
  FormsModule,
  ReactiveFormsModule
} from '@angular/forms';
import {RequestsService} from '../../../core/requests/requests.service';
import {DiagramJsonHandlerService} from '../../../diagram-data/diagram-json-handler.service';
import {MatDialogRef, MatDialogModule} from '@angular/material/dialog';
import {TranslateModule} from '@ngx-translate/core';
import {MatRadioModule} from '@angular/material/radio';
import {
  DialogCloseButtonComponent,
  InfoMessageComponent,
  PrimaryButtonComponent,
  SecondaryButtonComponent
} from '@q9elements/ui-kit/components';

@Component({
  selector: 'app-sync-urls-popup',
  templateUrl: './sync-urls-popup.component.html',
  styleUrls: ['./sync-urls-popup.component.scss'],
  standalone: true,
  imports: [
    FormsModule,
    ReactiveFormsModule,
    MatDialogModule,
    MatRadioModule,
    TranslateModule,
    DialogCloseButtonComponent,
    InfoMessageComponent,
    SecondaryButtonComponent,
    PrimaryButtonComponent
  ]
})
export class SyncUrlsPopupComponent implements OnInit {
  public syncForm: UntypedFormGroup;

  constructor(
    private requestsSvc: RequestsService,
    private dialogRef: MatDialogRef<SyncUrlsPopupComponent>,
    private diagramJsonSvc: DiagramJsonHandlerService
  ) {}

  ngOnInit() {
    this.syncForm = new UntypedFormGroup({
      radio: new UntypedFormControl('diagram')
    });
  }

  public sync() {
    this.requestsSvc.addToQueue(this.taskForSync, true).then(() => this.dialogRef.close(true));
  }

  get taskForSync() {
    return {
      isApi: true,
      method: 'POST',
      url: `/organizations/${this.diagramJsonSvc.get().team.id}/urllibrary/sync`,
      data: {
        children: this.syncForm.get('radio').value,
        id: this.diagramJsonSvc.get().diagramId,
        type: 'diagram'
      }
    };
  }
}
